<template>
  <div class="bg-white">
    <MaintenanceBanner />
    <LandingHeader />
    <router-view />
    <LandingFooter />
    <CookieBanner />
    <TenantSignupModal />
    <MaintenanceNotice />
    <LegalDocumentModal />
  </div>
</template>

<script setup>
import MaintenanceBanner from './components/landing/MaintenanceBanner.vue'
import MaintenanceNotice from './components/landing/MaintenanceNotice.vue'
import LandingHeader from './components/landing/LandingHeader.vue'
import LandingFooter from './components/landing/LandingFooter.vue'
import CookieBanner from './components/landing/CookieBanner.vue'
import TenantSignupModal from './components/landing/TenantSignupModal.vue'
import LegalDocumentModal from './components/landing/LegalDocumentModal.vue'
</script>
